// extracted by mini-css-extract-plugin
export default {"descriptionHeader":"descriptionStyles_descriptionHeader__zU5Iw"};